/* eslint-disable */
export function stringToArray(value: string) {
  if (!value) {
    return undefined
  }
  const arr = value.split(',')

  return arr
}

export function stringToNumberArray(value: string) {
  if (!value) {
    return undefined
  }
  const arr = value.split(',')
  if (Array.isArray(arr)) {
    return arr.map(i => Number(i))
  }
}

export function stringToBoolean(value: string) {
  if (!value) {
    return undefined
  }
  return Boolean(+value)
}

export function boolString(value: string) {
  if (!value) {
    return undefined
  }

  return `${Boolean(+value)}`
}

export function stringToNumber(value: string) {
  if (!value) {
    return undefined
  }
  const num = Number(value)
  if (isNaN(num)) {
    return undefined
  }

  return num
}

export function getSortBy(
  value: string,
  nameField = 'title',
  dateFiled = 'created'
) {
  switch (value) {
    case 'old':
      return {
        sortField: dateFiled,
        sortDirection: 1,
      }
    case 'position':
      return {
        sortField: 'position',
        sortDirection: 1,
      }
    case 'nameDesk':
      return {
        sortField: nameField,
        sortDirection: 1,
      }
    case 'nameAsk':
      return {
        sortField: nameField,
        sortDirection: -1,
      }
    default:
      return {
        sortField: dateFiled,
        sortDirection: -1,
      }
  }
}
